import { gql } from '@apollo/client';

const GET_COLLATERAL_FILE_UPLOAD_URL_MUTATION = gql`
  mutation getCollateralFileUploadURL($input: CollateralFileUploadURLInput!) {
    getCollateralFileUploadURL(input: $input) {
      URL
      Metadata
    }
  }
`;

export default GET_COLLATERAL_FILE_UPLOAD_URL_MUTATION;
